/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { css } from '@appd/uik';

export const Spacer = ({ height = 0 }) => (
  <hr className={css({ all: 'initial' }, { display: 'block', flexShrink: 0, height, pointerEvents: 'none' })} />
);
